import moment from 'moment'


function getToday() {
  return moment().set({
    'hour': 0,
    'minute': 0,
    'second': 0,
    'millisecond': 0,
  });
}

function getCurrentYear() {
  return new Date().getFullYear();
}

function getCurrentQuarterRange() {
  const currentYear = getCurrentYear();
  const currentQuarter = moment().quarter();
  let startMonth = ((currentQuarter - 1) * 3) + 1;
  let endMonth = startMonth + 2;
  startMonth = `0${startMonth}`.slice(-2);  // 01, 02, .. 12
  endMonth = `0${endMonth}`.slice(-2);

  return [
    moment(`${currentYear}-${startMonth}-01`).toDate(),
    moment(`${currentYear}-${endMonth}-01`).endOf('month').toDate(),
  ];
}

function getYearToDateRange() {
  const currentYear = getCurrentYear();
  let startMonth = 1;
  startMonth = `0${startMonth}`.slice(-2);  // 01, 02, .. 12

  return [
    moment(`${currentYear}-${startMonth}-01`).toDate(),
    moment().toDate(),
  ];
}

export {
  getToday,
  getCurrentYear,
  getCurrentQuarterRange,
  getYearToDateRange,
};
